import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, Location, CurrencyPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BootcampDetail } from '../models/bootcamp-detail.model';
import { MrpScrolltopComponent } from '../services/mrp-scrolltop/mrp-scrolltop.component';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';

@Component({
    selector: 'app-bootcamp-detail',
    templateUrl: './bootcamp-detail.component.html',
    styleUrls: ['./bootcamp-detail.component.css'],
    imports: [MrpScrolltopComponent, CurrencyPipe, SafeUrlPipe]
})
export class BootcampDetailComponent implements OnInit {

  bootcamp: BootcampDetail | null = null;
  displayedColumns: string[] = ['name', 'description', 'action'];
  isLoading = false;
  isInitiatingCheckout = false;
  item_CODE: string | null = null;
  isBrowser = false;

  
  constructor(private route: ActivatedRoute, private http: HttpClient, 
    private location: Location, 
    @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef) { 
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.item_CODE = this.route.snapshot.paramMap.get('code');

    this.isLoading = true;
    if (this.isBrowser) {
        this.http.post<BootcampDetail[]>('api/products/getBootcampDetails.php', {"item_CODE": this.item_CODE}).subscribe({
            next: (data) => {
              this.bootcamp = data[0];
              this.isLoading = false;
              this.cdr.markForCheck();
            },
            error: (error) => {
              console.error('Error fetching products:', error);
              this.isLoading = false;
              this.cdr.markForCheck();
            }
          });   
        this.logPage(this.route.snapshot.url.join('/'));
    } else {
      // Avoid server-side HTTP during prerender
      this.isLoading = false;
    }
   
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }

  goBack(): void {
    this.location.back();
  }

  async initiateCheckout(priceId?: string, mode: 'payment' = 'payment') {
    if (!priceId) {
      console.error('Missing priceId for checkout');
      return;
    }

    this.isInitiatingCheckout = true;
    this.http.post<{ sessionId: string, stripeKey: string, sessionUrl: string }>('api/create-checkout-session/create-checkout-session.php', { priceId, mode }).subscribe({
      next: async (response) => {
        // Redirect to Stripe Checkout
        window.location.assign(response.sessionUrl); // Redirect to Checkout
      },
      error: (error) => {
         this.isInitiatingCheckout = false;
        console.error('Error creating checkout session:', error);
        this.cdr.markForCheck();
      }
    });
  }

}
